/* eslint-disable @next/next/no-img-element */

import Head from "next/head";
import { useMemo } from "react";

import CMSLogic from "@/src/logic/CMSLogic";
import { StrapiComponentType } from "@/src/type";
import { LoadFromCDN } from "@/src/util";

import styles from "./ImageSizedModule.module.scss";

interface ImageSizedModuleProps {
  image?: StrapiComponentType.Element.ImageSized;
  lazy?: "eager" | "lazy";
  stylePrefix?: string;
  id: string | number;
  quality?: number;
}

function ImageSizedModule({ image, stylePrefix, id, quality = 90 }: ImageSizedModuleProps) {
  const url = image?.image?.data?.attributes?.url;
  const name = useMemo(() => `${stylePrefix ?? "ImageSizedModule"}_${id}`, [stylePrefix, id]);
  const style = CMSLogic.generateImageSizedBreakpointStyle(name, image?.breakpoints, url, image?.useDynamicWidth, image?.imgTag);
  const maxWidth = image?.breakpoints?.reduce((max, current) => {
    return current.width > max && current.widthUnit === "px" ? current.width : max;
  }, 0);

  if (!style) {
    return <></>;
  }

  return (
    <>
      <Head>
        <style
          id={`${name}`}
          type="text/css"
          dangerouslySetInnerHTML={{ __html: style ?? "" }}
        />
      </Head>
      {image?.imgTag ? (
        <div className={name}>
          <img
            src={`${LoadFromCDN.imageQualityAndSizeOptional(url, quality, !maxWidth ? undefined : maxWidth)}${image?.cdnParams ?? ""}`}
            alt={image?.name ?? "Image Sized Module"}
            className={styles.image}
          />
        </div>
      ) : (
        <div className={name} />
      )}
    </>
  );
}

export default ImageSizedModule;
